import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ApiService } from 'src/app/services/api.service'
import { AccountDto } from 'src/app/services/dtos'
import { UiService } from 'src/app/services/ui.service'
import { AccessLevelService } from 'src/app/services/access-level.service'
import { handleArpioError } from 'src/utils/handle-error'

@Component({
  selector: 'app-arpio-root',
  templateUrl: './arpio-root.component.html',
  styleUrls: ['./arpio-root.component.scss'],
  standalone: false,
})
export class ArpioRootComponent implements OnInit {
  private _accounts: AccountDto[] | null = null
  constructor(
    private apiService: ApiService,
    private uiService: UiService,
    private accessLevelService: AccessLevelService,
    private router: Router
  ) {}

  ngOnInit() {
    this.apiService.listAccounts().subscribe(
      (accounts: Array<AccountDto>) => {
        if (accounts.length === 1) {
          this.router.navigateByUrl(this.uiService.buildAccountRootUrl(accounts[0].accountId))
        } else {
          this._accounts = accounts
        }
      },
      handleArpioError(window.location.href, this.apiService, this.uiService, { redirectOn403: true })
    )
  }

  get accounts() {
    if (!this._accounts) {
      return null
    }

    return this._accounts.sort((l, r) => {
      if (l.name < r.name) {
        return -1
      }
      if (l.name > r.name) {
        return 1
      }
      return l.accountId < r.accountId ? -1 : 1
    })
  }

  logoutClick() {
    this.apiService.logout().subscribe(
      (nothing) => {
        // after logout, navigate to the root, which will re-direct to the login page
        window.location.href = '/'
      },
      handleArpioError(window.location.href, this.apiService, this.uiService)
    )
  }
}
